import { startOfDay, startOfMonth, startOfWeek, subDays } from "date-fns";

import { DateRangeSafe } from "../DashboardView/utils/useDateRangeFilter";

export const QUICK_DIAL_OPTIONS: {
  label: string;
  value: () => DateRangeSafe;
}[] = [
  {
    label: "This week",
    value: () => ({
      from: startOfWeek(new Date(), {
        weekStartsOn: 1,
      }),
      to: startOfDay(new Date()),
    }),
  },
  {
    label: "Last 7 days",
    value: () => ({
      from: subDays(startOfDay(new Date()), 6),
      to: startOfDay(new Date()),
    }),
  },
  {
    label: "This month",
    value: () => ({
      from: startOfMonth(new Date()),
      to: startOfDay(new Date()),
    }),
  },
  {
    label: "Last 30 days",
    value: () => ({
      from: subDays(startOfDay(new Date()), 29),
      to: startOfDay(new Date()),
    }),
  },
  {
    label: "Last 90 days",
    value: () => ({
      from: subDays(startOfDay(new Date()), 89),
      to: startOfDay(new Date()),
    }),
  },
];
